import { doApi } from './apiClient';
import type {
  Wrestler,
  WrestlerWithStats,
  WrestlerListFilters,
  PaginatedResponse,
  ApiResponse,
} from '../types';

export const apiGetWrestler = async (id: number): Promise<WrestlerWithStats> => {
  return doApi<WrestlerWithStats>(`api/wrestlers/get/${id}`, 'GET');
};

export const apiDeleteWrestler = async (id: number): Promise<ApiResponse<null>> => {
  return doApi<ApiResponse<null>>(`api/wrestlers/remove/${id}`, 'DELETE');
};

export const apiListWrestlerByInputSearch = async (
  searchName: string
): Promise<PaginatedResponse<Wrestler>> => {
  const body = { searchName };
  return doApi<PaginatedResponse<Wrestler>>('api/wrestlers/list', 'POST', body);
};

export const apiListWrestlerByOrder = async (
  orderBy: string,
  isOrderDesc: boolean,
  isFilterMan: boolean,
  isFilterWomen: boolean,
  isFilterManager: boolean
): Promise<PaginatedResponse<Wrestler>> => {
  const body: WrestlerListFilters = {
    orderBy: orderBy as WrestlerListFilters['orderBy'],
    isOrderDesc,
    isFilterMan,
    isFilterWomen,
    isFilterManager,
  };
  return doApi<PaginatedResponse<Wrestler>>('api/wrestlers/list', 'POST', body);
};

export const apiListWrestlerByOrderMobile = async (
  isFilterMan: boolean,
  isFilterWomen: boolean,
  isFilterManager: boolean,
  orderBy: string = 'name',
  isOrderDesc: boolean,
  searchName: string | null = null
): Promise<PaginatedResponse<Wrestler>> => {
  const body: WrestlerListFilters = {
    orderBy: orderBy ? (orderBy as WrestlerListFilters['orderBy']) : undefined,
    isOrderDesc,
    isFilterMan,
    isFilterWomen,
    isFilterManager,
    per_page: 16,
    searchName: searchName || null,
  };
  return doApi<PaginatedResponse<Wrestler>>('api/wrestlers/list', 'POST', body);
};

export const apiListWrestlerByPage = async (
  page: number
): Promise<PaginatedResponse<Wrestler>> => {
  return doApi<PaginatedResponse<Wrestler>>(`api/wrestlers/list?page=${page}`, 'GET');
};

export const apiListWrestlerByPageMobile = async (
  page: number
): Promise<PaginatedResponse<Wrestler>> => {
  return doApi<PaginatedResponse<Wrestler>>(
    `api/wrestlers/list?page=${page}&per_page=5000`,
    'GET'
  );
};

export const apiListWrestlerPaged = async (
  page: number,
  perPage: number
): Promise<PaginatedResponse<Wrestler>> => {
  return doApi<PaginatedResponse<Wrestler>>(
    `api/wrestlers/list?page=${page}&per_page=${perPage}`,
    'GET'
  );
};

export const apiListWrestler = async (): Promise<Wrestler[]> => {
  return doApi<Wrestler[]>('api/wrestlers/listall', 'GET');
};

export const apiCreateWrestler = async (data: FormData): Promise<ApiResponse<Wrestler>> => {
  return doApi<ApiResponse<Wrestler>>('api/wrestlers/create', 'POST', data, true);
};

export const apiEditWrestler = async (
  data: FormData,
  id: number
): Promise<ApiResponse<Wrestler>> => {
  return doApi<ApiResponse<Wrestler>>(`api/wrestlers/edit/${id}`, 'POST', data, true);
};

// V2 APIs
export const apiListWrestlersV2 = async (): Promise<Wrestler[]> => {
  return doApi<Wrestler[]>('api/wrestlers/v2/all', 'GET');
};

export const apiCreateWrestlerV2 = async (data: FormData): Promise<ApiResponse<Wrestler>> => {
  return doApi<ApiResponse<Wrestler>>('api/wrestlers/v2/create', 'POST', data, true);
};

export const apiEditWrestlerV2 = async (
  data: FormData,
  id: number
): Promise<ApiResponse<Wrestler>> => {
  return doApi<ApiResponse<Wrestler>>(`api/wrestlers/v2/edit/${id}`, 'POST', data, true);
};
